import { WEATHER_DETAIL_ICON_KEYS } from 'features/Weather/config/weatherDetailIcons.config';
import {
  getAlertEndTime,
  getAlertSender,
  getAlertSeverity,
  getAlertStartTime,
} from 'features/Weather/features/WeatherAlerts/utils/alertData.utils';
import { getAlertSeverityLabel } from 'features/Weather/features/WeatherAlerts/utils/alertSeverity.utils';
import { formatDateTime } from 'utils/dates/date.utils';

export const severeWeatherAlertDetails = [
  {
    id: 'severity',
    label: 'Severity',
    iconKey: WEATHER_DETAIL_ICON_KEYS.SEVERITY,
    getValue: (alert) => {
      const severity = getAlertSeverity(alert);
      return severity === null
        ? getAlertSeverityLabel(severity)
        : `${getAlertSeverityLabel(severity)} (${severity})`;
    },
  },
  {
    id: 'sender',
    label: 'Sender',
    iconKey: WEATHER_DETAIL_ICON_KEYS.SENDER,
    getValue: getAlertSender,
  },
  {
    id: 'starts',
    label: 'Starts',
    iconKey: WEATHER_DETAIL_ICON_KEYS.TIME,
    getValue: (alert) => formatDateTime(getAlertStartTime(alert)),
  },
  {
    id: 'ends',
    label: 'Ends',
    iconKey: WEATHER_DETAIL_ICON_KEYS.TIME,
    getValue: (alert) => formatDateTime(getAlertEndTime(alert)),
  },
];

export const severeWeatherAlertDetailGroups = [
  ['severity', 'sender'],
  ['starts', 'ends'],
];
